<template>
  <div
    class="fixed inset-0 flex items-end justify-center px-6 py-2 pointer-events-none sm:items-start sm:justify-end"
  >
    <div
      class="w-56 mr-40 bg-white shadow-lg rounded pointer-events-auto ring-1 border-1 border-gray-400 ring-black ring-opacity-5 overflow-hidden"
    >
      <div class="p-2">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <!-- Heroicon name: check-circle -->
            <svg
              class="w-4 h-4 mt-0.5 text-blue-900"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
              ></path>
            </svg>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-blue-900 text-xs font-medium">
              {{ $t('message.loadingnotification.cargando') }}...
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading-notification'
};
</script>
